import alert from '#utilities/js/ea/alert.js'
import globals from '#utilities/js/ea/globals.js'
import report from '#utilities/js/ea/report.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import stop, { hasReachedStop } from './stop.js'
import done from './done.js'
import { meetProps, scopeProps, setState, states } from './props.js'
import { display, displayVideos} from './ui.js'
import X from './meet_x.js'

export const cnx = (cbk, open, close, msg, err) => {
  const props = meetProps()
  if (!props.uri)
    return;
  const ws = new WebSocket(props.uri)
  ws.onopen = ((cbk) => {
    return (e) => {
      wsOpen(e)
      typeof cbk === 'function' && cbk()
    }
  })(cbk)
  ws.onclose = wsClose
  ws.onmessage = wsMsg
  ws.onerror = wsErr
  props.ws = ws
}


const wsOpen = (e) => {
  const props = meetProps()
  const { f, ws } = props
  let c = 'cnx'
  if (f === 1)
    c += 'f'
  ws.send(`${c}|${globals.ea_boundary}`)
}

const wsGenericErr = async (e) => {
  display('[data-meet="meet_stop"]')
  if (!hasReachedStop()) {
    stop({stayInMeetPage: true})
    const props = meetProps()
    const {msgs} = scopeProps()
    const {err_call} = msgs
    await alert(err_call)
    report(new Error('wsGenericErr: ' + JSON.stringify(e)))
    setState(states.ended)
  }
}

const wsClose = async e => wsGenericErr(e)

const wsMsg = (e) => {
  const props = meetProps()
  const {dial, caller, is_caller} = scopeProps()
  const tab = e.data.split('|')
  const [op, id, email, video] = tab
  let current_att
  if (op === 'dcnx') {
    for (let i = 0; i < props.atts.length; i++)
      if (id === props.atts[i].id) {
        current_att = props.atts[i]
        props.atts.splice(i, 1)
        break
      }
    if (dial && current_att && current_att.email === props.organizer)
      done()
    else if (!dial && props.atts.length === 0)
      done()
    return;
  }
  if (op === 'dcnxf') {
    display('[data-meet="meet_force"]')
    return;
  }
  if (op === 'accept') {
    if (props.st !== states.connect || !dial) {
      setState(states.wait)
      display('[data-meet="meet_wait"]')
    }
    if (dial) {
      /* now we choose to display everything */
      if (is_caller) {
        displayVideos()
      }
    }
    return
  }
  if (op === 'cnx') {
    if (props.st !== states.connect) {
      display('[data-meet="meet_accept"]')
      setState(states.accept)
    }
    const att = {id, email, video}
    for (let i = 0; i < props.atts.length; i++)
      if (att.email === props.atts[i].email) {
        const o = one(`#ea_video_att_${props.atts[i].id}`)
        if (o)
          remove(o)
        props.atts.splice(i, 1)
      }
    props.atts.push(att)
    X.onNewAttendee(att)
    return;
  }
  X.onMessage(e, tab)
}

const wsErr = async e => wsGenericErr(e)
